import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function MyShopCityLanding({ user, isAdmin }) {
  const navigate = useNavigate();
  const playStoreUrl =
    "https://play.google.com/store/apps/details?id=com.alanvillalba.myshopcity2025&pcampaignid=web_share";
  const appStoreUrl = "https://apps.apple.com/mx/app/my-shop-city/id6754808420";
  const contactEmail = "13alanvillalba07@gmail.com";

  // Responsive sin CSS externo
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 900);
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const steps = [
    {
      icon: icons.userPlus,
      title: "Te registras en la app",
      desc: "Crea tu cuenta y activa el modo vendedor para empezar.",
    },
    {
      icon: icons.box,
      title: "Subes productos gratis",
      desc: "Publica fotos, precio y descripción. No cobramos por aparecer.",
    },
    {
      icon: icons.tag,
      title: "Tú decides cuánto ganar",
      desc: "Tú pones tu precio y siempre verás claramente nuestra comisión.",
    },
    {
      icon: icons.truck,
      title: "Nosotros hacemos el envío",
      desc: "Solo dinos dónde recogemos el producto. Nosotros lo entregamos.",
    },
    {
      icon: icons.stripe,
      title: "Pagos seguros con Stripe",
      desc: "Procesamiento y registro seguro de pagos para ti y tus clientes.",
    },
  ];

  return (
    <div style={styles.page}>
      {/* Topbar (estilo V1, pero en blanco) */}
      <header style={styles.header}>
        <div style={styles.headerInner}>
          <a href="/" style={styles.brand}>
            <div style={styles.logoWrap}>
              <img
                src="/logo.png"
                alt="MyShopCity logo"
                style={styles.logoImg}
                onError={(e) => {
                  e.currentTarget.style.display = "none";
                  const fallback = e.currentTarget.nextSibling;
                  if (fallback) fallback.style.display = "flex";
                }}
              />
              <div style={{ ...styles.logoFallback, display: "none" }}>MSC</div>
            </div>

            <div>
              <div style={styles.brandName}>MyShopCity</div>
              <div style={styles.brandTag}>
                Marketplace local • Compras seguras
              </div>
            </div>
          </a>

          <nav style={styles.nav}>
            <a href="#como-funciona" style={styles.navLink}>Cómo funciona</a>
            <a href="#apps" style={styles.navLink}>Descargar</a>

            {/* ✅ Botón Login / Dashboard */}
            <button
              type="button"
              style={{
                ...styles.navBtn,
                ...(user && isAdmin ? styles.navBtnPrimary : styles.navBtnOutline),
              }}
              onClick={() => {
                if (user && isAdmin) navigate("/admin");
                else navigate("/login");
              }}
            >
              {user && isAdmin ? "Ir al Dashboard" : "Iniciar sesión"}
            </button>
          </nav>

        </div>
      </header>

      {/* fondos / formas suaves */}
      <div style={styles.bgGlowA} aria-hidden="true" />
      <div style={styles.bgGlowB} aria-hidden="true" />

      <main style={styles.main}>
        {/* HERO (V2) */}
        <section style={styles.hero}>
          {/* Nota V2 */}
          <div style={styles.note}>
            <span style={styles.noteDot} aria-hidden="true" />
            <span>Si ya te registraste, vuelve a la app para continuar.</span>
          </div>

          <div
            style={{
              ...styles.heroGrid,
              gridTemplateColumns: isMobile ? "1fr" : "1.05fr 0.95fr",
            }}
          >
            <div>
              <h1 style={styles.h1}>Vende productos en tu ciudad</h1>

              <p style={styles.pLead}>
                No te cobramos por aparecer en la app. Puedes subir productos gratis.
                Si tienes dudas, contáctanos con el chat dentro de la app.
                No esperes más y haz crecer tu negocio.
              </p>

              <div style={styles.badgesRow}>
                <div style={styles.badge}>Publica gratis</div>
                <div style={styles.badge}>Envío incluido</div>
                <div style={styles.badge}>Pagos con Stripe</div>
              </div>
            </div>

            {/* Pasos (5 iconos) */}
            <div style={styles.stepsWrap}>
              {steps.map((s, idx) => (
                <div key={idx} style={styles.stepCard}>
                  <div style={styles.stepIcon}>{s.icon}</div>
                  <div>
                    <div style={styles.stepTitle}>
                      {idx + 1}. {s.title}
                    </div>
                    <div style={styles.stepDesc}>{s.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Cómo funciona (V1) */}
        <section id="como-funciona" style={styles.section}>
          <h2 style={styles.h2}>Cómo funciona</h2>

          <div
            style={{
              ...styles.cardsGrid,
              gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)",
            }}
          >
            <div style={styles.card}>
              <div style={styles.cardTitle}>Para compradores</div>
              <p style={styles.cardText}>
                Explora productos, compra desde la app y recibe confirmación del pedido.
                Si hay un problema, puedes contactar a soporte.
              </p>
            </div>

            <div style={styles.card}>
              <div style={styles.cardTitle}>Para vendedores</div>
              <p style={styles.cardText}>
                Publica productos, define tus precios y recibe tus ganancias conforme
                al flujo de la plataforma y políticas aplicables.
              </p>
            </div>

            <div style={styles.card}>
              <div style={styles.cardTitle}>Pagos y seguridad</div>
              <p style={styles.cardText}>
                Los pagos se procesan digitalmente. Algunas funciones pueden depender
                de verificación de identidad y requisitos de cumplimiento.
              </p>
            </div>
          </div>
        </section>

        {/* Descargar (V1) con botones mejorados */}
        <section id="apps" style={styles.section}>
          <h2 style={styles.h2}>Descargar MyShopCity</h2>
          <p style={styles.p}>Elige tu plataforma para instalar la aplicación.</p>

          <div style={styles.storeRow}>
            <a
              href={playStoreUrl}
              target="_blank"
              rel="noreferrer"
              style={{ ...styles.storeBtn, ...styles.storeBtnPrimary }}
            >
              <div style={styles.storeSmall}>Android</div>
              <div style={styles.storeBig}>Google Play</div>
              <div style={styles.storeHint}>Instalar</div>
            </a>

            <a
              href={appStoreUrl}
              target="_blank"
              rel="noreferrer"
              style={{ ...styles.storeBtn, ...styles.storeBtnSecondary }}
            >
              <div style={styles.storeSmall}>iOS</div>
              <div style={styles.storeBig}>App Store</div>
              <div style={styles.storeHint}>Instalar</div>
            </a>
          </div>

          <div style={styles.noticeBox}>
            <div style={styles.noticeTitle}>Información para verificación de Stripe</div>
            <div style={styles.noticeText}>
              Esta página describe el negocio, ofrece enlaces públicos a las apps y
              muestra información de contacto para soporte al cliente.
            </div>
          </div>
        </section>

        {/* Contacto (V1) */}
        <section id="contacto" style={styles.section}>
          <h2 style={styles.h2}>Contacto</h2>
          <p style={styles.p}>
            Si necesitas ayuda o tienes preguntas sobre la plataforma, contáctanos:
          </p>

          <div style={styles.contactCard}>
            <div style={styles.contactLabel}>Correo</div>
            <div style={styles.contactEmail} >
              Chat en la App
            </div>
            <div style={styles.contactHint}>
              Tiempo de respuesta típico: 24–48 horas hábiles.
            </div>
          </div>
        </section>

        {/* ✅ Sobre los pagos (movido más al final) */}
        <section style={styles.section}>
          <div style={styles.payBox}>
            <div style={styles.payTitle}>Sobre los pagos</div>
            <div style={styles.payText}>
              El pago puede demorar unos días para asegurarle al cliente que su producto
              es lo que pidió. Entre mejor vendedor seas, menos tiempo retendremos tu dinero.
              Usamos Stripe para procesar y registrar pagos de forma segura.
            </div>
          </div>
        </section>

        {/* Footer simple */}
        <footer style={styles.footer}>
          <div style={styles.footerInner}>
            <div style={styles.footerLeft}>
              <div style={styles.footerBrand}>MyShopCity</div>
              <div style={styles.footerText}>
                Plataforma de compras locales. © {new Date().getFullYear()}
              </div>
            </div>

            <div style={styles.footerRight}>
              <a href="/support" style={styles.footerLink}>Soporte</a>
              <span style={styles.sep}>•</span>
              <a href="/terms-and-conditions" style={styles.footerLink}>Términos</a>
              <span style={styles.sep}>•</span>
              <a href="/privacy-policy" style={styles.footerLink}>Privacidad</a>
            </div>
          </div>
        </footer>
      </main>
    </div>
  );
}

/* ---------------- Icons ---------------- */
const icons = {
  userPlus: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
      <path d="M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" stroke="currentColor" strokeWidth="1.8"/>
      <path d="M19 8v6M22 11h-6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  ),
  box: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <path d="M21 8l-9 5-9-5 9-5 9 5Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/>
      <path d="M3 8v8l9 5 9-5V8" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/>
      <path d="M12 13v8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  ),
  tag: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <path d="M20.6 13.4 12 22l-10-10V2h10l8.6 8.6a2 2 0 0 1 0 2.8Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/>
      <path d="M7 7h.01" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round"/>
    </svg>
  ),
  truck: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <path d="M3 17V6a2 2 0 0 1 2-2h10v13H3Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/>
      <path d="M15 8h4l2 3v6h-6V8Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/>
      <path d="M7 20a1.8 1.8 0 1 0 0-3.6A1.8 1.8 0 0 0 7 20ZM17 20a1.8 1.8 0 1 0 0-3.6A1.8 1.8 0 0 0 17 20Z" stroke="currentColor" strokeWidth="1.8"/>
      <path d="M3 17h2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  ),
  stripe: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <path
        d="M7.5 7.2c0-1.1.9-1.9 2.6-1.9 1.4 0 3 .3 4.3 1V3.6c-1.4-.6-2.9-.9-4.3-.9C6.9 2.7 5 4.4 5 7.5c0 4.8 6.6 4 6.6 6 0 1-.9 1.7-2.7 1.7-1.6 0-3.4-.4-4.9-1.2v2.8c1.6.7 3.4 1.1 4.9 1.1 3.4 0 5.3-1.6 5.3-4.7 0-4.9-6.7-4-6.7-6Z"
        fill="currentColor"
        opacity="0.9"
      />
      <path d="M19 4v16" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" opacity="0.35"/>
    </svg>
  ),
};

/* ---------------- Styles (blanco, pro) ---------------- */
const styles = {
  page: {
    minHeight: "100vh",
    background: "linear-gradient(180deg, #f7f7fb 0%, #ffffff 55%, #f7f7fb 100%)",
    color: "#101114",
    fontFamily:
      'ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, "Helvetica Neue", Arial, "Noto Sans", "Apple Color Emoji","Segoe UI Emoji"',
    position: "relative",
    overflow: "hidden",
  },
  bgGlowA: {
    position: "absolute",
    top: -160,
    left: "50%",
    width: 780,
    height: 780,
    transform: "translateX(-55%)",
    background:
      "radial-gradient(circle, rgba(90,120,255,0.20) 0%, rgba(90,120,255,0.06) 35%, rgba(255,255,255,0) 70%)",
    pointerEvents: "none",
  },
  bgGlowB: {
    position: "absolute",
    top: -120,
    left: "50%",
    width: 620,
    height: 620,
    transform: "translateX(-10%)",
    background:
      "radial-gradient(circle, rgba(0,200,255,0.16) 0%, rgba(0,200,255,0.05) 35%, rgba(255,255,255,0) 70%)",
    pointerEvents: "none",
  },

  header: {
    position: "sticky",
    top: 0,
    zIndex: 10,
    backdropFilter: "blur(10px)",
    backgroundColor: "rgba(255,255,255,0.75)",
    borderBottom: "1px solid rgba(0,0,0,0.08)",
  },
  headerInner: {
    maxWidth: 1080,
    margin: "0 auto",
    padding: "14px 18px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 14,
  },
  brand: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    textDecoration: "none",
    color: "inherit",
  },
  logoWrap: {
    width: 44,
    height: 44,
    borderRadius: 14,
    background: "rgba(0,0,0,0.03)",
    border: "1px solid rgba(0,0,0,0.10)",
    display: "grid",
    placeItems: "center",
    overflow: "hidden",
  },
  logoImg: { width: "100%", height: "100%", objectFit: "cover", display: "block" },
  logoFallback: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 900,
    letterSpacing: 1,
    color: "rgba(16,17,20,0.82)",
  },
  brandName: { fontWeight: 900, fontSize: 16, lineHeight: 1.1 },
  brandTag: { fontSize: 12, opacity: 0.7, marginTop: 2 },

  nav: { display: "flex", gap: 12, flexWrap: "wrap" },
  navLink: {
    color: "rgba(16,17,20,0.82)",
    textDecoration: "none",
    fontSize: 13,
    padding: "8px 10px",
    borderRadius: 10,
    border: "1px solid rgba(0,0,0,0.08)",
    background: "rgba(255,255,255,0.9)",
  },

  main: { maxWidth: 1080, margin: "0 auto", position: "relative" },

  hero: { padding: "22px 18px 10px" },
  heroGrid: { display: "grid", gap: 18, alignItems: "start", marginTop: 14 },

  note: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "12px 14px",
    borderRadius: 14,
    background: "rgba(90,120,255,0.10)",
    border: "1px solid rgba(90,120,255,0.22)",
    color: "rgba(16,17,20,0.85)",
    fontSize: 13,
  },
  noteDot: {
    width: 10,
    height: 10,
    borderRadius: 999,
    background: "rgba(90,120,255,0.95)",
    boxShadow: "0 0 0 6px rgba(90,120,255,0.12)",
    flex: "0 0 auto",
  },

  h1: { fontSize: 36, lineHeight: 1.08, letterSpacing: -0.8, margin: "8px 0 10px", fontWeight: 950 },
  pLead: { fontSize: 15, opacity: 0.78, lineHeight: 1.6, margin: 0 },

  badgesRow: { display: "flex", gap: 10, marginTop: 14, flexWrap: "wrap" },
  badge: {
    fontSize: 12,
    padding: "8px 10px",
    borderRadius: 999,
    border: "1px solid rgba(0,0,0,0.08)",
    background: "rgba(255,255,255,0.85)",
    opacity: 0.95,
  },

  stepsWrap: { display: "grid", gap: 10 },
  stepCard: {
    display: "flex",
    gap: 12,
    alignItems: "flex-start",
    padding: 14,
    borderRadius: 16,
    border: "1px solid rgba(0,0,0,0.08)",
    background: "rgba(255,255,255,0.85)",
    boxShadow: "0 14px 45px rgba(0,0,0,0.06)",
  },
  stepIcon: {
    width: 44,
    height: 44,
    borderRadius: 14,
    border: "1px solid rgba(0,0,0,0.10)",
    background: "rgba(0,0,0,0.02)",
    display: "grid",
    placeItems: "center",
    color: "rgba(16,17,20,0.88)",
    flex: "0 0 auto",
  },
  stepTitle: { fontWeight: 950, fontSize: 14, letterSpacing: -0.2 },
  stepDesc: { marginTop: 6, fontSize: 13, opacity: 0.72, lineHeight: 1.45 },

  section: { padding: "18px 18px 6px" },
  h2: { fontSize: 20, margin: "10px 0 10px", letterSpacing: -0.2, fontWeight: 950 },
  p: { margin: 0, opacity: 0.78, lineHeight: 1.6 },

  cardsGrid: { display: "grid", gap: 12, marginTop: 14 },
  card: {
    borderRadius: 16,
    border: "1px solid rgba(0,0,0,0.08)",
    background: "rgba(255,255,255,0.85)",
    padding: 14,
    boxShadow: "0 14px 45px rgba(0,0,0,0.06)",
  },
  cardTitle: { fontWeight: 950, fontSize: 14 },
  cardText: { margin: "8px 0 0", opacity: 0.76, lineHeight: 1.55, fontSize: 13 },

  storeRow: { display: "flex", gap: 12, flexWrap: "wrap", marginTop: 14 },
  storeBtn: {
    flex: "1 1 220px",
    textDecoration: "none",
    borderRadius: 16,
    border: "1px solid rgba(0,0,0,0.08)",
    padding: 16,
    color: "#101114",
    display: "block",
    background: "rgba(255,255,255,0.9)",
    boxShadow: "0 18px 55px rgba(0,0,0,0.08)",
  },
  storeBtnPrimary: {
    background:
      "linear-gradient(180deg, rgba(90,120,255,0.92), rgba(70,100,245,0.92))",
    color: "white",
    border: "1px solid rgba(90,120,255,0.25)",
  },
  storeBtnSecondary: {
    background: "rgba(255,255,255,0.95)",
  },
  storeSmall: { fontSize: 12, opacity: 0.9 },
  storeBig: { fontSize: 18, fontWeight: 950, marginTop: 4 },
  storeHint: {
    marginTop: 10,
    fontSize: 12,
    fontWeight: 950,
    opacity: 0.95,
    display: "inline-block",
    padding: "8px 10px",
    borderRadius: 999,
    border: "1px solid rgba(0,0,0,0.08)",
    background: "rgba(255,255,255,0.85)",
    color: "inherit",
  },

  noticeBox: {
    marginTop: 14,
    borderRadius: 16,
    border: "1px solid rgba(0,0,0,0.08)",
    background: "rgba(255,255,255,0.85)",
    padding: 14,
    boxShadow: "0 14px 45px rgba(0,0,0,0.06)",
  },
  noticeTitle: { fontWeight: 950, fontSize: 13 },
  noticeText: { marginTop: 6, fontSize: 13, opacity: 0.76, lineHeight: 1.5 },

  contactCard: {
    marginTop: 12,
    borderRadius: 16,
    border: "1px solid rgba(0,0,0,0.08)",
    background: "rgba(255,255,255,0.85)",
    padding: 14,
    display: "grid",
    gap: 6,
    boxShadow: "0 14px 45px rgba(0,0,0,0.06)",
  },
  contactLabel: { fontSize: 12, opacity: 0.7 },
  contactEmail: { color: "rgba(70,100,245,0.95)", fontWeight: 950, textDecoration: "none" },
  contactHint: { fontSize: 12, opacity: 0.7 },

  payBox: {
    borderRadius: 16,
    border: "1px solid rgba(0,0,0,0.08)",
    background: "rgba(255,255,255,0.85)",
    padding: 14,
    boxShadow: "0 14px 45px rgba(0,0,0,0.06)",
  },
  payTitle: { fontWeight: 950, fontSize: 14 },
  payText: { marginTop: 6, fontSize: 13, opacity: 0.76, lineHeight: 1.55 },

  footer: { padding: "28px 18px 34px" },
  footerInner: {
    maxWidth: 1080,
    margin: "0 auto",
    borderTop: "1px solid rgba(0,0,0,0.08)",
    paddingTop: 16,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    flexWrap: "wrap",
  },
  footerBrand: { fontWeight: 950 },
  footerText: { fontSize: 12, opacity: 0.7, marginTop: 4 },
  footerLeft: {},
  footerRight: { display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" },
  footerLink: { fontSize: 12, color: "rgba(16,17,20,0.78)", textDecoration: "none" },
  sep: { opacity: 0.35 },
};
